import styled from 'styled-components';

export const StyledPaddingWrapper = styled.div`
    padding: 0 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
